export const ROUTE_CONSTANTS = {
    AUTHORIZE_OUTLOOK: '/authorize/outlook',
    AUTHORIZE_WORD: '/authorize/word',
    AUTHORIZE_PAGES: './pages/authorize',
    WORD: 'word',
    OUTLOOK: 'outlook',
}
